import * as Actions from './actions';

export default {
  namespaced: true,
  state: {
    monitorMessages: [],
    unreadMonitorMessages: [],

    consumerMessages: [],
    consumerOpenMessages: [
      {
        userToken: '',
        fullName: '',
        unRead: false,
      },
    ],

    tracker: [],
    kioskMode: [],
  },
  getters: {
    monitorMessages: state => state.monitorMessages,
    unreadMonitorMessages: state => state.unreadMonitorMessages,

    consumerMessages: state => state.consumerMessages,
    consumerOpenMessages: state => state.consumerOpenMessages,

    tracker: state => state.tracker,
    kioskMode: state => state.kioskMode,
    monitorCountUnreadMessages: state => state.unreadMonitorMessages.length,
  },
  mutations: {
    monitorMessages: (state, messages) => {
      state.monitorMessages = messages;
    },
    pushMonitorMessages: (state, message) => {
      state.monitorMessages.push(message);
    },
    unreadMonitorMessages: (state, unread) => {
      state.unreadMonitorMessages = unread;
    },

    consumerMessages: (state, messages) => {
      state.consumerMessages = messages;
    },
    pushConsumerMessages: (state, message) => {
      state.consumerMessages.push(message);
    },
    consumerOpenMessages: (state, openMessages) => {
      state.consumerOpenMessages = openMessages;
    },

    tracker: (state, trackerEmployee) => {
      state.tracker = trackerEmployee;
    },
    kioskMode: (state, kioskMode) => {
      state.kioskMode = kioskMode;
    },
  },
  actions: {
    ...Actions,
  },
};
